import { assign } from 'xstate';
import { Context } from '../companyInfo';

const assignArraySuccessData = assign<Context, any>((ctx, evt) => ({
    isFetching: false,
    data: evt.data,
}));

export default assignArraySuccessData;
